import React from "react";
import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { BsPlus } from "react-icons/bs";

const toneStyles = {
  red: { bg: "red.50", color: "red.700" },
  orange: { bg: "orange.50", color: "orange.800" },
  green: { bg: "green.50", color: "green.700" },
};

const SectionValidationMessage = ({ messages = [], onAddRow }) => {
  if (!messages.length) return null;

  return (
    <Box>
      {messages.slice(0, 3).map((item, index) => {
        const style = toneStyles[item.tone] || toneStyles.orange;
        return (
          <HStack key={`${item.message}-${index}`} mt={2} justify="space-between" bg={style.bg} borderRadius="md" px={3} py={2} gap={3}>
            <Text fontSize="sm" color={style.color}>{item.message}</Text>
            {onAddRow && /row|required/i.test(item.message) ? (
              <Button size="xs" variant="outline" leftIcon={<BsPlus />} onClick={onAddRow}>
                Add row
              </Button>
            ) : null}
          </HStack>
        );
      })}
    </Box>
  );
};

export default SectionValidationMessage;
